import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-[#E8DCC4] last:border-0" data-id="element-1">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-5 flex items-center justify-between text-left hover:text-[#D4AF37] transition-colors" data-id="element-2">
        <span className="text-lg font-semibold text-[#8B7355] pr-4" data-id="element-3">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-[#D4AF37] flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-4" />
      </button>

      <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-5' : 'max-h-0'}`} data-id="element-5">
        <p className="text-[#3A3226] leading-relaxed" data-id="element-6">{answer}</p>
      </div>
    </div>;
}